import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
const SESSION_EXPIRED_MESSAGE =
  "Your session has expired. Please log in again.";
const AUTH_FREE_PATHS = [
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
];
let authRedirectStarted = false;

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("authToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 && !authRedirectStarted) {
      authRedirectStarted = true;
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("userDetails");
      sessionStorage.setItem(
        "sessionExpiredMessage",
        SESSION_EXPIRED_MESSAGE,
      );

      const currentPath = window.location.pathname;
      const isAuthFreePath = AUTH_FREE_PATHS.some((path) =>
        currentPath.startsWith(path),
      );

      if (!isAuthFreePath) {
        window.location.assign("/login");
      }
    }

    return Promise.reject(error);
  },
);

export default api;
